import {
  PURCHASE,
  CLEAR_PURCHASE,
} from "@/actions/types";

export default function purchase (state = {}, action: {type: string, payload: {postId: string}}) {
  const { type, payload } = action;

  switch (type) {
    case PURCHASE:
      return {
        ...state,
        postId: payload.postId,
      };
    case CLEAR_PURCHASE:
      return {
        ...state,
        postId: null,
      };
    default:
      return state;
  }
}
